import { SheetSection } from "Components/Common/ProfileSheet/ProfileSheetEditor";

/** Sections of the person profile's list editors (alias names, contacts). */

export const ALIAS_SECTIONS: SheetSection[] = [
  {
    kind: "list",
    id: "alias",
    label: "Alias names",
    icon: "ri-user-shared-line",
    noun: "alias name",
    plural: "alias names",
    placeholder: "Other name the person is known by",
    hint: "Previous names, spellings and nicknames, so searches find the person.",
  },
];

export const CONTACT_SECTIONS: SheetSection[] = [
  {
    kind: "list",
    id: "phoneNumber",
    label: "Phone numbers",
    icon: "ri-phone-line",
    noun: "phone number",
    plural: "phone numbers",
    placeholder: "For example +252 61 234 5678",
    inputType: "tel",
    hint: "Include the country code.",
    check: "phone",
  },
  {
    kind: "list",
    id: "emailAddress",
    label: "Email addresses",
    icon: "ri-mail-line",
    noun: "email address",
    plural: "email addresses",
    placeholder: "name@example.org",
    inputType: "email",
    check: "email",
  },
  {
    kind: "single",
    id: "websiteOrLink",
    label: "Website or link",
    icon: "ri-global-line",
    placeholder: "www.example.org",
    hint: "A personal site or profile page, if there is one.",
    check: "web",
  },
  {
    kind: "address",
    id: "physicalAddress",
    label: "Physical addresses",
    icon: "ri-map-pin-2-line",
    noun: "physical address",
    plural: "physical addresses",
  },
  {
    kind: "address",
    id: "postalAddress",
    label: "Postal addresses",
    icon: "ri-mail-send-line",
    noun: "postal address",
    plural: "postal addresses",
  },
];
